import { MetaMaskCircleIcon, WalletConnectCircleIcon } from '@/icons'
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useConnect } from 'wagmi'

export const WalletOptionsModal = ({ ...props }) => {
  const { connect, connectors } = useConnect()
  const handleConnectorClick = (connector) => {
    connect({ connector })

    props.onClose()
  }

  const walletIconsMapping = {
    MetaMask: <MetaMaskCircleIcon boxSize={8} />,
    WalletConnect: <WalletConnectCircleIcon boxSize={8} />,
  }

  return (
    <>
      <Modal isCentered {...props}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Connect Wallet</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <HStack>
              {connectors?.map((connector) => (
                <VStack
                  key={connector.id}
                  onClick={() => handleConnectorClick(connector)}
                  bg={'primary.0'}
                  p={4}
                  rounded={'md'}
                  cursor={'pointer'}
                  _hover={{ bg: 'primary.50', color: 'primary.500' }}
                  boxShadow={'base'}
                >
                  {walletIconsMapping[connector.name]}
                  <Text>{connector.name}</Text>
                </VStack>
              ))}
            </HStack>
          </ModalBody>

          <ModalFooter>
            <Button variant={'outline'} onClick={() => props.onClose()}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
